export default "__VITE_ASSET__dFF1Lqd3__"